import Vue from "vue";
import {PersonnelService,} from "@/common/api.service";
import {
    FETCH_PERSON_EMPLOYMENTS_END,
    FETCH_PERSONNEL_EMPLOYMENTS_END,
    LOAD_PERSON_EMPLOYMENT_TO_EDIT,
    RESET_DEFAULT_NEW_PERSON_EMPLOYMENT,
    RESET_DEFAULT_NEW_PERSON_EMPLOYMENT_LIST,
    RESET_DEFAULT_PERSON_EMPLOYMENT_TO_EDIT,
    TOGGLE_EDIT_PERSON_EMPLOYMENT_DIALOG,
    TOGGLE_NEW_PERSON_EMPLOYMENT_DIALOG,
    UPDATE_ADD_PERSON_EMPLOYMENT_FIELD,
    UPDATE_PERSON_EMPLOYMENT_FIELD,
} from "./mutations.js";
import {DELETE_PERSON_EMPLOYMENT, FETCH_PERSON_EMPLOYMENT_LIST, FETCH_PERSONNEL_EMPLOYMENT_LIST, SAVE_EDITED_PERSON_EMPLOYMENT, SAVE_NEW_PERSON_EMPLOYMENT} from "./actions.js"
import {SET_TOASTER_MESSAGE,} from "../this_app/mutations";

const enumerateDaysBetweenDates = function (startDate, endDate) {
    const dates = [];

    const currDate = moment(startDate).startOf('day');
    const lastDate = moment(endDate).startOf('day');

    dates.push(currDate.format('YYYY-MM-DD'));

    while (currDate.add(1, 'days').diff(lastDate) < 0) {
        dates.push(currDate.clone().format('YYYY-MM-DD'));
    }

    dates.push(lastDate.format('YYYY-MM-DD'));

    return dates;
};
const state = {
    hasOpenEmployment: false,
    employmentTypeList: [],
    personnelEmploymentList: [],
    personEmploymentList: [],
    employedDates: [],
    editPersonEmployment: {
        jobId: false,
        employmentTypeId: false,
        weeklyHours: false,
        startDate: false,
        endDate: false,
        comments: false,
        isAllowedToil: false,
        isAllowedExpenses: false,
    },
    addPersonEmployment: {
        jobId: undefined,
        employmentTypeId: undefined,
        weeklyHours: undefined,
        startDate: undefined,
        endDate: undefined,
        comments: undefined,
        isAllowedToil: false,
        isAllowedExpenses: false,
    },
    addPersonEmploymentDialog: false,
    editPersonEmploymentDialog: false,
};

const getDefaultState = () => {
    return {
        employmentTypeList: [],
        personnelEmploymentList: [],
        personEmploymentList: [],
        editStateEmployment: {
            ecsCompanyId: false,
            jobId: false,
            employmentTypeId: false,
            weeklyHours: false,
            startDate: false,
            endDate: false,
            comments: false,
            isAllowedToil: false,
            isAllowedExpenses: false,
        },
        editPersonEmployment: {
            ecsCompanyId: false,
            jobId: false,
            employmentTypeId: false,
            weeklyHours: false,
            startDate: false,
            endDate: false,
            comments: false,
            isAllowedToil: false,
            isAllowedExpenses: false,
        },
        defaultPersonEmployment: {
            ecsCompanyId: undefined,
            jobId: undefined,
            employmentTypeId: undefined,
            weeklyHours: undefined,
            startDate: undefined,
            endDate: undefined,
            comments: undefined,
            isAllowedToil: false,
            isAllowedExpenses: false,
        },
        addPersonEmployment: {
            ecsCompanyId: undefined,
            jobId: undefined,
            employmentTypeId: undefined,
            weeklyHours: undefined,
            startDate: undefined,
            endDate: undefined,
            comments: undefined,
            isAllowedToil: false,
            isAllowedExpenses: false,
        },
        addPersonEmploymentDialog: false,
        editPersonEmploymentDialog: false,
    }
};

const getters = {
    hasOpenEmployment(state) {
        return state.hasOpenEmployment;
    },

    editPersonEmploymentPersonId(state) {
        if (state.personEmploymentList.length) {
            if (state.personEmploymentList[0].personId != 'undefined') {
                return state.personEmploymentList[0].personId;
            }
        }
    },

    addPersonEmploymentDialog(state) {
        return state.addPersonEmploymentDialog;
    },

    livePersonnelWithJobList: (state, getters) => (jobId) => {
        const matches = state.personnelEmploymentList.filter(personEmployment => personEmployment.jobId == jobId);
        const newList = [];
        const livePersonnelList = getters.livePersonnel();

        matches.forEach(function (element) {
            const personFromList = livePersonnelList.find(person => person.personId == element.personId);

            if (personFromList != undefined) {
                newList.push(personFromList);
            }
        });

        return newList;
    },
    personnelWithJobCount: (state, getters) => (jobId) => {
        const matches = state.personnelEmploymentList.filter(personEmployment => personEmployment.jobId == jobId);
        const newList = [];
        const livePersonnelList = getters.livePersonnel();

        matches.forEach(function (element) {
            const personFromList = livePersonnelList.find(person => person.personId == element.personId && person.isLive == 1);

            if (personFromList != undefined) {
                newList.push(personFromList);
            }
        });

        return newList.length;
    },
    personEmploymentList(state) {
        // let frozenPersonEmploymentList = Object.freeze(state.personEmploymentList);
        // let jsonedPersonEmploymentList = JSON.parse(JSON.stringify(frozenPersonEmploymentList));
        // return jsonedPersonEmploymentList;
        return state.personEmploymentList;
    },
};

const actions = {
    [FETCH_PERSONNEL_EMPLOYMENT_LIST]({commit}) {
        return PersonnelService.getPersonnelEmployments()
            .then(({data}) => {

                commit(FETCH_PERSONNEL_EMPLOYMENTS_END, data);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to fetch employment'});
            });
    },
    [FETCH_PERSON_EMPLOYMENT_LIST]({commit}, personId) {
        if (personId == undefined) {
            return false;
        }
        return PersonnelService.getPersonEmployments(personId)
            .then(({data}) => {
                commit(RESET_DEFAULT_NEW_PERSON_EMPLOYMENT_LIST);
                commit(FETCH_PERSON_EMPLOYMENTS_END, data);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to fetch employment'});
            });
    },
    [SAVE_NEW_PERSON_EMPLOYMENT]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const newPersonEmployment = state.addPersonEmployment;
        return PersonnelService.savePersonEmployment(newPersonEmployment)
            .then(() => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record saved'});
                dispatch(FETCH_PERSON_EMPLOYMENT_LIST, newPersonEmployment.personId);
                // return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to save employment'});
            });
    },
    [SAVE_EDITED_PERSON_EMPLOYMENT]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const editedPersonEmployment = state.editPersonEmployment;
        return PersonnelService.updatePersonEmployment(editedPersonEmployment)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record updated'});
                commit(RESET_DEFAULT_PERSON_EMPLOYMENT_TO_EDIT);
                dispatch(FETCH_PERSON_EMPLOYMENT_LIST, editedPersonEmployment.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to update employment'});
            });
    },

    [DELETE_PERSON_EMPLOYMENT]({dispatch, commit}, params) {
        return PersonnelService.deletePersonEmployment(params.personEmploymentId)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record deleted'});
                dispatch(FETCH_PERSON_EMPLOYMENT_LIST, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to delete employment'});
            });
    },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [RESET_DEFAULT_NEW_PERSON_EMPLOYMENT](state, personId) {
        state.addPersonEmployment = getDefaultState().defaultPersonEmployment;
        state.addPersonEmployment.personId = personId;
    },
    [RESET_DEFAULT_NEW_PERSON_EMPLOYMENT_LIST](state) {
        // state.personEmploymentList = [];
        state.employedDates = [];
        state.personEmploymentList = getDefaultState().personEmploymentList;
    },
    [TOGGLE_NEW_PERSON_EMPLOYMENT_DIALOG](state) {
        state.addPersonEmploymentDialog = !state.addPersonEmploymentDialog;
    },

    [TOGGLE_EDIT_PERSON_EMPLOYMENT_DIALOG](state) {
        state.editPersonEmploymentDialog = !state.editPersonEmploymentDialog;
    },
    [UPDATE_ADD_PERSON_EMPLOYMENT_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.addPersonEmployment[data.objectKey][0][data.key] = data.value;
        } else {
            state.addPersonEmployment[data.key] = data.value;
        }
    },
    [UPDATE_PERSON_EMPLOYMENT_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.editPersonEmployment[data.objectKey][0][data.key] = data.value;
        } else {
            state.editPersonEmployment[data.key] = data.value;
        }
    },
    [FETCH_PERSONNEL_EMPLOYMENTS_END](state, data) {

        state.personnelEmploymentList = data;
        //state.articlesCount = articlesCount;
        state.isLoading = false;
    },
    [FETCH_PERSON_EMPLOYMENTS_END](state, data) {
        state.personEmploymentList = [];
        state.employedDates = [];
        state.hasOpenEmployment = false;
        for (let employment of data) {
            if (employment.endDate == null) {
                employment.endDate = '';
                state.hasOpenEmployment = true;
            } else {
                state.employedDates.push(enumerateDaysBetweenDates(employment.startDate, employment.endDate));
            }
            state.personEmploymentList.push(employment);
        }

        state.employedDates = [].concat(...state.employedDates);
        state.employedDates = [...new Set(state.employedDates)];

        state.isLoading = false;
    },
    [RESET_DEFAULT_PERSON_EMPLOYMENT_TO_EDIT](state) {
        state.editPersonEmployment = getDefaultState().defaultPersonEmployment;
    },
    [LOAD_PERSON_EMPLOYMENT_TO_EDIT](state, employmentId) {
        // noinspection UnnecessaryLocalVariableJS
        const itemToEdit = state.personEmploymentList.find((list) =>
            list.personEmploymentId == employmentId);
        state.editPersonEmployment = itemToEdit;
    },
};

const namespaced = false;

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
